import type { Transaction } from "@/apis/gql/types";
import getAccountTypeIcon from "@/lib/miscellaneous/get-account-type-icon";
import { cn } from "@/lib/utils";
import { RawTextCell } from "../cells/text";

export function BankTransactionBankAccountIcon({
  transaction,
  showBankName = false,
}: { transaction: Transaction; showBankName?: boolean }) {
  const AccountIcon = getAccountTypeIcon(transaction.bankAccount.type);
  const bankIconUrl = transaction.bankConnection?.metadata?.bank.icon?.url;
  const bankName = transaction.bankConnection?.metadata?.bank.name;

  return (
    <div className="flex items-center space-x-2 p-1">
      <div
        className={cn(
          "relative h-8 w-8 rounded-lg flex items-center justify-center",
          "border border-border bg-secondary/50 flex-shrink-0",
        )}
      >
        <AccountIcon className="h-4 w-4 text-muted-foreground" />
        {bankIconUrl && (
          <div className="absolute right-[-6px] bottom-[-4px] h-5 w-5 bg-white rounded border border-gray-200 flex items-center justify-center overflow-hidden box-border p-0.5">
            <img
              src={bankIconUrl}
              alt={bankName}
              className="max-h-full max-w-full object-contain"
            />
          </div>
        )}
      </div>
      {showBankName && (
        <RawTextCell value={transaction.bankAccount.name ?? ""} />
      )}
    </div>
  );
}
